export var ESelectorItemVariants = /* @__PURE__ */ ((ESelectorItemVariants2) => {
  ESelectorItemVariants2["SIMPLE"] = "simple";
  ESelectorItemVariants2["CHECK"] = "check";
  ESelectorItemVariants2["COMPACT"] = "compact";
  return ESelectorItemVariants2;
})(ESelectorItemVariants || {});
export var ESelectorItemElements = /* @__PURE__ */ ((ESelectorItemElements2) => {
  ESelectorItemElements2["ROOT"] = "root";
  ESelectorItemElements2["BADGE"] = "badge";
  ESelectorItemElements2["HEADER_CONTAINER"] = "headerContainer";
  ESelectorItemElements2["BADGE_LABEL_CONTAINER"] = "badgeLabelContainer";
  ESelectorItemElements2["LABEL"] = "label";
  ESelectorItemElements2["RADIO"] = "radio";
  ESelectorItemElements2["RADIO_INDICATOR"] = "radioIndicator";
  ESelectorItemElements2["RADIO_INDICATOR_ICON"] = "radioIndicatorIcon";
  ESelectorItemElements2["PARAGRAPH"] = "paragraph";
  return ESelectorItemElements2;
})(ESelectorItemElements || {});
